import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { InfoCircle } from '@kula-ai/icons/outline/InfoCircle';

export const OverallEvaluationBanner = () => {
  const color = '#454647';
  const iconColor = '242, 153, 74';
  const bgColor = '#FFF2CC';

  const renderCircleIcon = () => {
    return (
      <Box display="inline-block" p="12px">
        <Box
          width="46px"
          height="46px"
          borderRadius="full"
          border="2px solid "
          borderColor={`rgba(${iconColor}, 0.15)`}
          display="flex"
          padding="4px"
          alignItems="center"
          justifyContent="center"
        >
          <Box
            width="100%"
            height="100%"
            borderRadius="full"
            border="2px solid"
            display="flex"
            borderColor={`rgba(${iconColor}, 0.3)`}
            alignItems="center"
            justifyContent="center"
          >
            <Icon
              w="20px"
              h="20px"
              as={InfoCircle}
              color={`rgba(${iconColor})`}
            />
          </Box>
        </Box>
      </Box>
    );
  };
  return (
    <Flex bgColor={bgColor} borderRadius="6px">
      {renderCircleIcon()}
      <Flex flexDir="column" w="100%" gap="4px" p="14px 0">
        <Text color={color} size="md-bold">
          Needs your action!
        </Text>
        <Text color={color} size="sm-medium">
          AI does not fill the overall evaluation to ensure a fair and equitable
          interview
        </Text>
      </Flex>
    </Flex>
  );
};
